import { reactive } from 'vue'

export const drawer = reactive({
    lis: [
        { icon:'mdi-scan-helper', title: 'Scanner', navigation: 'CouponEntry', isNavigation: true },
        { icon:'mdi-ticket-percent', title: 'Listes de coupons', navigation: 'CouponLists', isNavigation: true },
        { icon:'mdi-ticket-account', title: 'Listes de comptes', navigation: 'AccountLists', isNavigation: true },
        { icon: 'mdi-star-outline', iconSrc: '/icons/benefits.svg', title: 'Avantages', navigation: 'CorporateBenefits', isNavigation: true },
        { icon: 'mdi-bell-outline', title: 'Notifications envoyées', navigation: 'Notifications', isNavigation: true },
        { icon: 'mdi-account-group-outline', title: 'Utilisateurs', navigation: 'Users', isNavigation: true },
        { icon:'mdi-calendar-clock', title: 'Dates de paiement', navigation: 'PaymentDates', isNavigation: true },
        { icon:'mdi-account-edit-outline', title: 'Demandes de modifications', navigation: 'ModificationRequests', isNavigation: true },
        { icon:'mdi-logout', title: 'Se déconnecter', navigation: '', isNavigation: false  },
    ],
    open: false
});
